import classNames from 'classnames/bind';
import { withPriceSeperator } from '@flight-workspace/common-client/src/util/number';
import { IFare } from 'list/international/types';
import { getPriceOfPerson } from 'list/international/utils';
import styles from './index.module.scss';
import { getPriceByCount } from './utils';

const cx = classNames.bind(styles);

const PassengerPriceItem = ({
  count,
  fareItem,
  isDiscountPromotion,
  passengerKor,
}: {
  count: number;
  fareItem: IFare;
  isDiscountPromotion: boolean;
  passengerKor: string;
}) => {
  return (
    <span className={cx('PassengerPriceItem')}>
      <span className={cx('name')}>
        <span className={cx('txt')}>{passengerKor}</span>
        <b className={cx('num')}>
          {withPriceSeperator(getPriceOfPerson(fareItem, isDiscountPromotion))}
        </b>
        <span className={cx('txt')}>원 x</span>
        <b className={cx('num')}>{count}</b>
        <span className={cx('txt')}>명</span>
      </span>
      <span className={cx('price')}>
        <b className={cx('num')}>
          {withPriceSeperator(
            getPriceByCount(fareItem, count, isDiscountPromotion),
          )}
        </b>
        <span className={cx('unit')}>원</span>
      </span>
    </span>
  );
};

export default PassengerPriceItem;
